import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { CustomerCategory } from '@/types';
import { useDeleteCustomerCategoryMutation } from '@/services';

export interface DeleteCustomerCategoryProps extends DialogProps {
  customerCategory: CustomerCategory;
  onClose(): void;
}

const DeleteCustomerCategory: React.FC<DeleteCustomerCategoryProps> = ({ customerCategory, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteCustomerCategory, deleteCustomerCategoryResponse] = useDeleteCustomerCategoryMutation();

  async function handleDeleteCustomerCategory() {
    try {
      await deleteCustomerCategory(customerCategory).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{customerCategory?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{customerCategory?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disabled={deleteCustomerCategoryResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteCustomerCategoryResponse.isLoading}
          onClick={handleDeleteCustomerCategory}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCustomerCategory;
